__turbopack_context__.v({
  "avatar": "styles-module-scss-module__glUb6G__avatar",
  "avatarImg": "styles-module-scss-module__glUb6G__avatarImg",
  "card": "styles-module-scss-module__glUb6G__card",
  "cardHeader": "styles-module-scss-module__glUb6G__cardHeader",
  "chevron": "styles-module-scss-module__glUb6G__chevron",
  "container": "styles-module-scss-module__glUb6G__container",
  "controls": "styles-module-scss-module__glUb6G__controls",
  "desc": "styles-module-scss-module__glUb6G__desc",
  "icon": "styles-module-scss-module__glUb6G__icon",
  "initials": "styles-module-scss-module__glUb6G__initials",
  "name": "styles-module-scss-module__glUb6G__name",
  "nameContainer": "styles-module-scss-module__glUb6G__nameContainer",
  "navBtn": "styles-module-scss-module__glUb6G__navBtn",
  "person": "styles-module-scss-module__glUb6G__person",
  "prev": "styles-module-scss-module__glUb6G__prev",
  "root": "styles-module-scss-module__glUb6G__root",
  "slide": "styles-module-scss-module__glUb6G__slide",
  "stars": "styles-module-scss-module__glUb6G__stars",
  "text": "styles-module-scss-module__glUb6G__text",
  "title": "styles-module-scss-module__glUb6G__title",
  "title_mb": "styles-module-scss-module__glUb6G__title_mb",
  "title_text": "styles-module-scss-module__glUb6G__title_text",
  "title_text_1": "styles-module-scss-module__glUb6G__title_text_1",
  "title_text_2": "styles-module-scss-module__glUb6G__title_text_2",
  "viewport": "styles-module-scss-module__glUb6G__viewport",
});
